var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.85714V12.5447C15 13.6493 14.1046 14.5447 13 14.5447H3C1.89543 14.5447 1 13.6493 1 12.5447V5.85715C1 5.13943 1.38457 4.47674 2.00772 4.12066L7.00772 1.26351C7.62259 0.912162 8.37741 0.912162 8.99228 1.26351L13.9923 4.12066C14.6154 4.47674 15 5.13943 15 5.85714ZM0 5.85715C0 4.78058 0.576858 3.78654 1.51158 3.25241L6.51158 0.39527C7.43388 -0.131757 8.56612 -0.131757 9.48842 0.395271L14.4884 3.25241C15.4231 3.78654 16 4.78057 16 5.85714V12.5447C16 14.2016 14.6569 15.5447 13 15.5447H3C1.34315 15.5447 0 14.2016 0 12.5447V5.85715ZM12.424 6.30982C12.2776 6.54398 11.9692 6.61517 11.735 6.46882L8 4.13444L4.265 6.46882C4.03083 6.61517 3.72236 6.54398 3.576 6.30982C3.42965 6.07565 3.50083 5.76717 3.735 5.62082L7.735 3.12082C7.89714 3.01948 8.10286 3.01948 8.265 3.12082L12.265 5.62082C12.4992 5.76717 12.5704 6.07565 12.424 6.30982ZM10.5 12.0448C10.5 12.321 10.2761 12.5448 10 12.5448H8H6C5.72386 12.5448 5.5 12.321 5.5 12.0448C5.5 11.7687 5.72386 11.5448 6 11.5448H8H10C10.2761 11.5448 10.5 11.7687 10.5 12.0448Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardblack);
export default __webpack_public_path__ + "static/media/dashboardblack.6d20a37558f07afe120544ca73d66102.svg";
export { ForwardRef as ReactComponent };